export default {
  'zh-cn': {
    flag: '中国',
    shopManagement: '店铺管理者',
    estimatedPaymentAmount: '预付款额度',
    common: {
      search: '搜索',
    },
    footer: {
      address: 'Ergosleep Building 3F, Nonhyeon-ro 721 Gangnam-gu, Seoul, Korea',
      customerService: 'Customer Service 822-1577-0564',
      companyNameKorean: 'B1SOFT CO.,LTD',
      companyCeoName: 'CEO: Choi Seok Woong',
      businessLicenseNumberText: 'Business License Number',
      businessLicenseNumber: '816-87-01138',
      companyNameEnglish: 'B1SOFT., LTD B1SOFT',
    },
    currency: {
      kr: {
        text: 'KRW',
        symbol: '₩',
      },
      us: {
        text: 'USD',
        symbol: '$',
      },
    },
    grade: {
      Rookie: '新手',
      Beginner: '初学',
      Amateur: '业余',
      SemiPro: '半职业',
      Pro: '职业',
      TourPro: '顶尖职业',
      Challenger: '挑战者',
    },
    gender: {
      man: '男性',
      woman: '女性',
      unLimit: '不限',
    },
    menu: {
      shopInfoManagement: '店铺管理信息',
      gameRoundOptionOptionManagement: '下场选项管理',
      drivingRangeOptionOptionManagement: '练习场选项管理',
      realtimeControlOptionManagement: '实时选项管理',
      agreement: '条款',
      signOut: '登出',
    },
    signIn: {
      id: '账号',
      password: '密码',
      forgotId: '忘记账号',
      forgotPassword: '忘记密码',
      rememberMe: '维持登录状态',
      buttonSignIn: '登录',
      cookie: 'Cookie 删除',
      cookieMessage: 'Cookie 已被删除。',

      fail: '登录失败。请再试一次。',
    },
    notification: {
      title: '通知',
      no: '编号',
      roomName: '球道名称',
      callTime: '称呼时间',
      message: '信息',
      confirm: '确认',
      noNotificationMSG: '没有调用通知消息。',

      billing_automatic_payment_failed: '[K-Golf 自动付款失败通知] 您的 K-Golf 自动付款失败。${payment_date} 之后，您将无法使用练习场以外的内容。如需支付未付款项或获取更多信息，请联系客户服务。[客户服务] ${customer_center_number}',
      billing_automatic_payment_guide: '[K-Golf 自动付款提醒] 您的 K-Golf 自动付款计划在 ${payment_date} 进行。请确保您的账户状态正常。如果付款未在计划日期完成，${payment_date} 之后，您将无法使用练习场以外的内容。[客户服务] ${customer_center_number}',
      billing_automatic_payment_success: '[K-Golf 付款成功通知] 您的 K-Golf 自动付款已成功完成。',
      billing_content_restrictions_notice: '[K-Golf 使用限制通知] 由于未在付款截止日期前完成付款，${payment_date} 之后，您将无法使用练习场以外的内容。如需支付未付款项或获取更多信息，请联系客户服务。[客户服务] ${customer_center_number}',
      billing_manual_payment_guide: '[K-Golf 手动付款期间通知] 您的付款期间为 ${start_date} 至 ${end_date}（共 ${diff_day} 天）。如果在此期间未完成付款，${end_date} 之后，您将无法使用练习场以外的内容。[客户服务] ${customer_center_number}',

      game_client_additional_access_game_round_approval_failed: '未能批准 ${client_name} 的额外回合使用请求。',
      game_client_additional_access_game_round_request: '${client_name} 请求额外回合使用。',
      game_client_additional_access_game_round_request_reject: '拒绝了 ${client_name} 的额外回合使用请求。',

      game_client_cancel_shot_failed: '未能取消 ${client_name} 的最后一杆。',
      game_client_cancel_shot_failed_2: '玩家已用尽所有取消机会。',
      game_client_cancel_shot_failed_3: '游戏进行中，取消失败。',
      game_client_cancel_shot_failed_4: '没有可取消的击球。',
      game_client_cancel_shot_success: '${client_name} 的最后一杆已成功取消。',

      game_client_extended_wait_success: '${client_name} 已切换至等待模式。',

      game_client_force_disconnection_failed: '未能强制断开 ${client_name} 的连接。',
      game_client_force_disconnection_success: '${client_name} 的连接已成功断开。',

      game_client_guest_login_failed: '未能登录 ${client_name} 的游客账户。',
      game_client_guest_login_success: '${client_name} 的游客登录成功。',

      game_client_limit_change_failed: '未能发送 ${client_name} 的控制选项更改。',
      game_client_limit_change_success: '${client_name} 的控制选项已成功更新。',

      game_client_lock_failed: '未能锁定 ${client_name}。',
      game_client_lock_success: '${client_name} 已被锁定。',

      game_client_player_count_change_failed: '未能更改 ${client_name} 的玩家数量。',
      game_client_player_count_change_request_reject: '已拒绝 ${client_name} 的玩家数量更改请求。',
      game_client_player_count_change_success: '${client_name} 的玩家数量已从 ${n} 人更改为 ${player_count} 人。',

      game_client_reset_mulligan_failed: '未能重置 ${client_name} 的暂缓击球次数。',
      game_client_reset_mulligan_success: '${client_name} 的暂缓击球次数已重置。',

      game_client_shop_manager_call_request: '${client_name} 请求店铺经理帮助。',

      game_client_time_extension_failed: '未能延长 ${client_name} 的使用时间。',
      game_client_time_extension_request: '${client_name} 请求延长使用时间。',
      game_client_time_extension_request_reject: '已拒绝 ${client_name} 的使用时间延长请求。',
      game_client_time_extension_success_1: '${client_name} 的使用时间已延长 ${add_time} 分钟。',

      game_client_unlock_failed: '未能解锁 ${client_name}。',
      game_client_unlock_success: '${client_name} 已解锁。',

      game_client_user_login_failed: '未能登录 ${client_name} 的用户账户。',
      game_client_user_login_success: '${client_name} 的用户登录成功。',

      kms_notice: '${title}',

      quit_game_client_failed: '未能处理 ${client_name} 的退出请求。',
      quit_game_client_success: '${client_name} 的退出请求已成功完成。',

      run_game_client_failed: '未能启动 ${client_name} 的游戏。',
      run_game_client_success: '${client_name} 的游戏已成功启动。'
    },
    dashboard: {
      content: 'Dashboard',
    },
    gameHistory: {
      searchPeriod: '搜索期间',
      userNickname: '会员昵称',
      userNicknamePlaceholder: '请输入昵称',
      search: '搜索',
      gameType: '游戏类型',
      shopClient: '打位',
      all: '所有',
      gameHistoryStatistics: '游戏历史统计',
      gameHistoryStatisticsNoticeText: '搜索结果的统计。',
      gameMode: '游戏类型',
      normalGame: '一般游戏',
      drivingRange: '练习场',
      swingDiagnosis: '挥杆诊断',
      userType: '会员分类',
      user: '会员',
      guest: '嘉宾',
      gender: '性别',
      male: '男',
      female: '女',
      times: '时间',
      gameRoundList: '游戏回合列表',
      gameNumbers: '游戏编号',
      clientName: '球道名称',
      numberPlayers: '选手数',
      numberHolesCompleted: '已完成洞数',
      startDate: '开始时间',
      endDate: '结束时间',
      more: '查看更多',
      close: '折叠',
      download: 'Download',
      alert: {
        message1: '必须至少选择一个蝙蝠座位',
        message2: '必须至少选择一种游戏类型',
        message3: '期限最多只能选择3个月。',
        message4: '根据搜索数据量可能会延迟。\\n确定要进行吗？',
        message5: 'No data',
      },
    },
    clientStatus: {
      sendMessage: '发送信息',
      statusInfo: '状态信息',
      proceeding: '处理中',
      endUse: '游戏结束',
      blind: '已锁定',
      lobby: '大厅',
      clientOff: '程序关闭',
      course: '球场',
      playerCount: '选手数',
      remainingTime: '剩余时间',
      start: '开始',
      paymentType: '付款类别',
      usageModeSetting: '设置模式',
      gameType: '游戏类型',
      usageTimeSetting: '使用时间设置',
      holeType: '球洞类别',
      drivingRangeTime: '练习场使用时间',
      noLimit: '无限',
      stroke: '击球',
      drivingRange: '练习场',
      minutes: '分钟',
      lessThanMinute: '少于一分钟',
      paymentProgress: '后付款正在进行中',
      peopleCount: '人员',
      noDrivingRange: '无',
      status: '状态',
      usageTime: '使用时间',
      usageCourse: '利用球场',
      usagePeopleCount: '玩家人数',
      addGuest: '添加游客',
      extendedTime: '延长的时间',
      scorecard: '计分卡',
      changeSetting: '变更设定',
      resetMulligan: '重置摸杆',
      cancelShot: '取消拍摄',
      bilnd: '已锁定',
      currentHole: '目前洞',
      sound : '通知声音',
      clientType : '击球时分类',
      popup: {
        close: 'close',
        addGuest: {
          addGuest: '添加游客',
          guestNicknamePlaceholder: '输入游客名称',
          cancel: '取消',
        },
        shotCancel: {
          confirmMessage: '将取消「${clientName}」打席的最后一杆。',
          shotCancel: '查看',
          cancel: '消除',
        },
        sendMessage: {
          sendMessage: '发送信息',
          all: '所有',
          cancel: '取消',
          messagePlaceholder: '请输入要发送的信息',
        },
        extendedTime: {
          extendedTime: '延长的时间',
          minutes: '分钟',
          addServiceTime: '添加服务时间',
          cancel: '取消',
        },
        changeSetting: {
          changeSetting: '变更设定',
          cancel: '取消',
        },
      },
      alert: {
        message1: '选择付款方式',
        message2: '请选择使用时间设置',
        message3: '请选择使用模式设置',
        message4: '请选择游戏类型',
        message5: '请选择孔类型',
        message6: '请选择玩家人数',
        message7: '请选择练习时间',
        message8: '请确认要锁屏吗？',
        message9: '请稍后再试',
        message10: '请确认初始化目前进行中游戏的摸杆吗？',
        message11: '因没有下场ID信息, 无法申请初始化',
        message12: '您想更改打位控制设定吗？',
        message13: '您想更改下场设定吗？',
        message14: '请选择传送信息的打位',
        message15: '请输入信息',
        message16: '该打位是后付费，所以不能延长时间。',
        message17: '请重新选择需要延长的时间',
        message18: '请输入游客昵称',
        message19: '因可登录的人员数不足，无法申请游客登录',
        message20: '由于没有游戏回合 ID 信息，因此您无法请求取消击球。',

        message1000: '下场设定更改功能准备中',
      },
    },
    billing: {
      tossPay: {
        addressTitle: '收货地址',
        clearAddressButton: '清空地址',
        clearAddressTooltip: '保留收件人/电话，仅清空地址',
        recipientPlaceholder: '收件人',
        phonePlaceholderKrw: '联系电话（例：010-1234-5678）',
        phonePlaceholderIntl: '联系电话（可含国家区号）',
        postcode: '邮编',
        searchAddressButton: '查找地址',
        address1Krw: '基本地址',
        address2Krw: '详细地址（栋/房号等）',
        address1Intl: '地址第一行',
        searchHint: '搜索…',
        address2Intl: '地址第二行（公寓、单元等）',
        country: '国家',
        city: '城市',
        state: '州/省/地区',
        postalIntl: '邮编 / ZIP',
        saveNoteKrw: '※ 结算时会保存收货地址。',
        saveNoteIntl: '※ 您的收货地址将随付款一并保存。',
        fedexTitle: 'FedEx 账号',
        fedexPlaceholder: '请输入 FedEx 账号',
        fedexNote: '※ 用于到付（Collect）寄送。',
        // ▼ 新增
        fedexHelpTitle: '还没有 FedEx 账号？',
        fedexHelpDesc: '请通过以下链接创建。',
        fedexGlobalLink: '创建 FedEx 账号（全球）',
        fedexUSLink: '创建 FedEx 账号（美国）',
        fedexGuideLink: '如何创建 FedEx 账号？（FAQ）',
        paymentMethodsTitle: '支付方式',
        agreeRequired: '需同意支付服务条款与隐私政策。',
        enterShipping: '请输入收货地址。',
        enterFedex: '请输入 FedEx 账号。',
        payNow: '立即支付',
        cardLabel: '信用卡',
        paypalLabel: 'PayPal',
        alipayLabel: '支付宝',
      }
      ,
      paymentInfo: {
        ownerDefaultInfo: '店主默认信息',
        shopName: '店铺名称',
        shopOwnerName: '店主名称',
        shopAddress: '店铺地址',
        shopAddressChangeNoticeText: '如需更改您的店铺地址，请联系客服中心',
        receiveBillInfoChange: '更改账单信息',
        receiveBillInfoChangeNoticeText: '接收每月的费用清单',
        shopOwnerMobilePhone: '店主联系信息',
        editButton: '编辑',
        mobileBill: '移动端信息',
        mobileBillNoticeText: '每月将使用费用明细表发送到店主的手机或邮箱。',
        sendButton: '发送',
        shipsFirstDayEveryMonth: '每个月1号邮寄',
        mobileBillNoAuth: '如果您不执行移动信息身份验证，您将无法接收付款对账单。',
        shopOwnerEmail: '店主邮箱地址',
        authenticateButton: '验证按钮',
        emailBill: '邮箱声明',
        emailBillNoticeText: '月结单将发送到注册店主的电子邮件',
        emailBillNoAuth: '如果您不执行移动信息身份验证，您将无法接收付款对账单。',
      },
      recurringPayment: {
        noRecurringPaumentServiceNoticeText1: '没有登记定期付款服务。',
        noRecurringPaumentServiceNoticeText2: '只有注册了定期支付服务，才能查看定期支付管理。',
        agreementToUseRecurringPaymentService: '同意使用定期支付服务',
        guide: '定期支付服务登记',
        whatIsRecurringPaymentService: '什么是定期付款服务？',
        recurringPaymentServiceDescription:
          '这是每月在总公司 K-Golf 指定的付款日期自动提取付款金额的服务。<br/>如果您使用常规付款服务，最大付款金额为 2。有 %<br/> 的费率折扣',
        agreeTermsConditionsRecurringPayment: '同意定期付款的条款和条件',
        allAgreement: '完整的协议',
        required: '必要的',
        termsOfRecurringPaymentService: '定期结算服务条款',
        personalInformationProvidedThirdParties: '同意向第三者提供个人资料',
        entrustingHandlingOfPersonalInformation: '同意委托处理个人信息',
        useAgreementButtonText: '定期结算服务条款',
        useAgreementNoticeText: '使用协议通知文本',
        recurringPaymentService: '定期付款服务条款',
        status: '状态',
        statusApplyingText: '应用现状',
        statusUseText: '在使用',
        serviceStartDate: '服务开始日期',
        automaticPaymentDueDate: '自动付款截止日期',
        discountRate: '折扣',
        recurringPaymentServiceCancel: '取消定期付款服务',
        bankAccountRegistrationAndManagement: '银行账户的注册和管理',
        bankAccount: '银行账户',
        bankAccountNumber: '银行账户号码',
        bankAccountName: '银行账户名称',
        management: '管理',
        addBankAccount: '添加银行账户',
        deleteBankAccount: '删除银行账户',
        noBankAccountNoticeText: '没有注册账号。<br/>点击右侧的账号注册按钮进行账号注册',
        creditCardRegistrationAndManagement: '信用卡登记和管理',
        creditCard: '信用卡',
        creditCardNumber: '信用卡号码',
        noCreditCardNoticeText: '没有已注册的卡。<br/>请点击右侧的卡注册按钮进行卡注册',
        addCreditCard: '卡片注册',
        deleteCreditCard: '删除卡片',
        recurringPaymentNoticeText: '如果在自动支付服务中同时注册了<strong style={{color:"#333333"}}>帐户</strong>和卡 >',
      },
      paymentProgress: {
        text1: '支付信息正在被验证',
        text2: '请稍等',
      },
      paymentComplete: {
        text1: '支付成功',
        text2: '（使用虚拟账户付款时，确认入账后方可使用服务）',
        buttonText: '完成',
      },
      paymentFail: {
        text1: '支付失败',
        text2: '',
        buttonText: '关闭',
      },
      paymentCancel: {
        text1: '取消支付',
        text2: '',
        buttonText: '关闭',
      },
      payment: {
        generalPayment: '一般费用支付',
        prepayment: '预期金额预支付',
        paymentUnpaidCharges: '支付未支付的费用',

        chargesText: '支付金额为<spanclass="price">|charges|</span><spanstyle="font-size"',
        checkPaymentHistory: '请检查支付详情',
        billingMonth: '支付月度',
        amountBePaid: '需支付金额',
        details: '详情',
        choosePaymentMethod: '选择支付方式',
        realTimeAccountTransfer: '银行转账',
        creditCardPayment: '信用卡支付',

        tab1: {
          text1: '目前没有需要支付的一般费用',
          text2: '没有需要支付的金额',
          text3: '一般费用支付周期',
          text4: '一般费用只能从每月1日起支付, 直到本公司指定的付款日期为止。',
          text5: '支付截止日期',
          text6: '一般费用支付周期',
          text7: '每个月',
          text8: '日期',
        },
        tab2: {
          text1: '目前无法提前支付',
          text2: '没有需要支付的金额',
          text3: '预支付周期',
          text4: '预支付只能从每月1日起支付, 直到本公司指定的付款日期为止。',
          text5: '支付截止日期',
          text6: '一般费用支付周期',
          text7: '每个月',
          text8: '日期',
        },
        tab3: {
          text1: '没有未支付金额',
          text2: '您可以在本公司指定的付款日期后支付未付金额。',
          text3: '支付日期',
          text4: '每个月',
          text5: '日期',
          text6: '预支付可用',
          text7: '预支付只能从每月1日起支付, 直到本公司指定的付款日期为止。',
          text8: '支付截止日期',
          text9: '预支付周期',
        },
      },
      bills: {
        monthPaymentAmount: '|month|付款金额',
        usagePeriod: '使用周期',
        clientName: '客户姓名',
        usageAmount: '使用数量',
        discountAmount: '折扣数',
        paymentAmount: '支付数',
        contentPlan: '内容计划',
        coursePlan: '球场计划',
        minutes: '分钟',
        course: '球场',
        totalCharges: '总金额',
        count: '总数',
        coutseUnlimit: '无限',
        vat: '增值税',
        currentMonthTotalCharges: '月度总金额',
        totalAmount: '总数额',
      },
      paymentHistory: {
        text1: '您只能搜索过去12个月的记录。',
        billMonth: '发行月度账单',
        charges: '金额',
        paymentStatus: '支付状态',
        paymentSuccess: '支付成功',
        unpayment: '不付款',
      },
      itemPaymentHistory: {
        info01: '为了确认您的收货，请检查您购买商品时输入的电子邮件地址。',
        info02: '如需申请退款，请联系客服。',
        date: '购买日期',
        orderNumber: '订单号',
        purchaseItem: '购买物品',
        charges: '付款金额',
        paymentMethod: '付款方式',
        materialCode: '物料代码',
        quantity:     '数量',
        paymentMethods: {
          CA:              '信用卡',
          AccountTransfer: '银行转账',
          PZ:              'PZ支付',
          EASYPAY:         '易支付',
        },
        statuses: {
          0: '商品准备中',
          1: '已发货',
          2: '已送达',
          3: '退款',
        },
      },
    },
    customerService: {
      notice: {
        postType: '类别',
        searchPlaceholder: '搜索字符',
        postTitle: '标题',
        registrationDate: '注册日期',
        attachments: '附件',
        moveListButtonText: '列表',
        postTypeCode: {
          notice: 'Notice',
          update: 'Update',
          event: 'Event',
        },
      },
      qna: {
        test: 'test',
      },
    },
    edit: {
      shopInfoSetting: {
        clientTypeAlert: '必须检查至少一种击球类型。',

        shopInfo: '商铺信息',
        shopName: '店铺名称',
        shopPhoneNumber: '商铺电话',
        shopAddress: '店铺地址',
        shopOwnerName: '店主名称',
        shopOwnerMobilePhone: '店主电话',

        shopSalesInfo: '商铺销售信息',
        operatingTime: '营业时间',
        operatingTimePlaceholder: '例)\n平日 AM 08:00 ~ PM:12:00 \n周末/公休日 AM 06:00 ~ PM 12:00',
        screen: '屏幕',
        practiceRange: '练习本',
        lesson: '辅导',
        convenientFacilities: '便利设施',
        swingPlate: '摆动板',
        leftHanded: '两打',
        parking: '停车场',
        equipmentStorage: '设备保管',
        proLesson: '职业辅导',
        fee: '使用费',
        feePlaceholder: '例）\n详细价格请联系商店。',
        storeView: '商店视图',
        parkingNotice: '停车信息',
        parkingPlaceholder: '例）\n免费停车（使用大厦停车场）',
        storeIntroduce: '卖场介绍',
        storeIntroducePlaceholder: '例）\n会努力让所有人都能舒适地享受高尔夫。 \n一直感谢您的光临。',
        clientList: '打位列表',
        clientName: '客户姓名',
        clientOrder: '打位订单',
        clientInfo: '打位信息',
        clientType: '打位类别',
        cancel: '取消',
        saveChanges: '保存更改',
      },
      shopGameRoundOptionSetting: {
        title: '回合选项管理',
        concede: '认输',
        holecupPosition: '球杯位置',
        mulliganCount: '摸杆数',
        swingPlate: '动感平台',
        distanceUnit: '距离单位',
        greenPosition: '果岭位置',
        greenSpeed: '果岭速度',
        windStrength: '风力',
        puttingLine: '推杆线路',
        bestVideo: '最佳回放',
        continuePutting: '继续推杆',
        caddyVoice: '球童声音',
        noPuttMode: '跳过推杆',
        obTeeAndHazardTee: '出界发球台和落水发球台',
        on: '开启',
        off: '关闭',
        saveChanges: '保存更改',
        shotInfoLocation: '高尔夫挥杆情报',
        side: '侧面',
        bottom: '下端',
        greenHardness: '果岭硬度',
        guideDistance: '目标距离',
        maxScoreFactor: '每孔最大行程数',
      },
      shopDrivingRangeOptionSetting: {
        title: '练习场选项管理',
        course: '球场',
        drivingRange1: 'KGOLF',
        drivingRange2: '張家界',
        drivingRange3: '圣淘沙',
        drivingRange4: '隐藏城堡',
        drivingRange5: 'KGOLF2',
        difficulty: '难易度',
        teeHeight: '发球台高度',
        windStrength: '风速',
        distanceUnit: '距离单位',
        swingPlate: '动感平台',
        ballTrajectory: '球轨迹',
        fixedCamera: '固定相机',
        swingVideo: '挥杆影像',
        on: '打开',
        off: '关闭',
        saveChanges: '保存更改',
      },
      shopClientRealTimeControlOptionSetting: {
        title: '标题',
        paymentType: '支付类别',
        usageTimeSetting: '使用时间设置',
        usageModeSetting: '设置模式',
        noLimit: '无限',
        stroke: '击球',
        drivingRange: '练习场',
        usageContentSetting: '内容设置',
        availablePlayerCountSetting: '玩家数量设置',
        holeType: '球洞类别',
        drivingRangeTime: '练习场使用时间',
        saveChanges: '保存更改',
        peopleUnit: '人员',
        none: '无',
        minutes: '分钟',
      },
      accountInfoSetting: {
        accountInfo: '账户信息',
        name: '名称',
        id: 'ID',
        password: '密码',
        changePassword: '更改密码',
        newPasswordPlaceholder: '请输入新密码。',
        cancel: '取消',
        submit: '更改',
        validation: '密码可设置为4至12个字符，须包括数字、小写英文字母、大写英文字母。',
        successful: '账户密码已更改。',
        fail: '更改密码失败。',
      },
      clientInfoSetting: {
        clientInfo: '更改客户端密码',
        password: '密码',
        changePassword: '更改密码',
        newPasswordPlaceholder: '请输入新密码（4位数字）。',
        cancel: '取消',
        submit: '更改',
        validation: '密码只能设置为4位数字。',
        successful: '所有商店客户的密码已更改。',
        fail: '更改密码失败。',
      },
    },
    scorecard: {
      title: '计分卡',
      gameNumbers: '比赛编号',
      gameType: '游戏类型',
      courseName: '球场名称',
      gameHoleType: '球洞类型',
      shopName: '店铺名称',
      shopClientName: '球道名称',
      startTime: '开始时间',
      endTime: '结束时间',
      concede: '认输',
      holeCupPosition: '球杯位置',
      mulligan: '摸杆',
      greenPosition: '果岭位置',
      greenSpeed: '果岭速度',
      swingPlate: '动感平台',
      windStrength: '风力',
      distanceUnit: '距离单位',
      puttingLine: '推杆线路',
      bestVideo: '最佳回放',
      caddyVoice: '球童声音',
      whetherUseObTeeAndHazardTee: '出界发球和落水发球',
      use: '使用',
      unused: '未使用的',
      stroke: '击球',
      newPerio: '新贝利亚计分',
      ranking: '排名',
      team: '队伍',
      nickname: '昵称',
      handicap: '差点',
      close: '关闭',
      alertText1: '游戏进行中',
      grade: '等级',
      greenHardness: '果岭硬度',
      guideDistance: '目标距离',
      maxScoreFactor: '每孔最大行程数',
      on: '开启',
      off: '关闭',
    },
    alert: {
      comingSoon: '敬请期待',
      unusualApproach: '这是一个不寻常的策略',
      deletePaymentMethodSuccess: '付款方式已被成功删除',
      deletePaymentMethodFail: '付款方式删除失败',
      shopRecurringPaymentCancelSuccess: '已完成取消订阅付款',
      shopRecurringPaymentCancelFail: '取消订阅付款失败',
    },
    popup: {
      title: {
        sendMessage: '传送信息',
        scorecard: '计分卡',
        addGuest: '添加游客',
        shotCancel: '射击取消',
        extendedTime: '延长时间',
        changeSetting: '设定更改',
        courseSelection: '球场设定',
        rankingCriteriaGameRoundCount: '按比赛记录多的顺序指的是？',
        rankingCriteriaBackCount: '后半场计分方式指的是？',
        shopTournamentOpenConfirm: '比赛开设确认',
        shopTournamentModifyConfirm: '比赛修改确认',

        deleteTournamentConfirm: '预订比赛删除说明',
        earlyEndTournamentConfirm: '比赛提前结束说明',
        resetAwardsConfirm: '名单初始化说明',
        awardRecipientsSelectionConfirm: '授奖者选定确认',
        tournamentAwardAnnouncementConfirm: '授奖者发布确认',
        contentsItemPayment: '内容使用指南',
        callNotification: '称呼通知',
      },
      button: {
        close: 'Close',
        cancel: '取消',
        confirm: '确认',
        announcement: '公布。',
      },
    },
    agreement: {
      terms: '经营者使用条约',
      privacy: '个人信息处理条款',
      refund: '退款规定',
      termsText:
          '作为屏幕高尔夫系统的开发商及制造商的K-GOLF，与正在通过K-GOLF屏幕高尔夫系统运营盈利业务的业主（店主）之间，关于系统使用的条款规定如下。\n\n' +
          '第1条（目的）\n' +
          '本条款（以下简称“条款”）旨在规定用户与株式会社K-GOLF（以下简称“公司”）之间，关于公司提供的服务（屏幕高尔夫服务）及互联网相关服务、网页与移动服务的使用，以及公司与业主之间的权利、义务与责任事项及其他必要事项。\n\n' +
          '第2条（术语的定义）\n' +
          '1. “业主”指安装了公司批准提供服务的K-GOLF产品，并在门店以盈利为目的开展业务的经营者代表。\n' +
          '2. “K-GOLF门店”（以下简称“营业场所”）指业主购买了K-GOLF产品，并安装了经公司批准提供服务的K-GOLF产品的门店。\n' +
          '3. “K-GOLF产品”指由K-GOLF开发并生产的屏幕高尔夫系统。\n' +
          '4. “用户客户”指到访营业场所，使用K-GOLF产品并根据营业场所的使用费用政策支付费用的客户。\n' +
          '5. “计费”指使用公司开发的K-GOLF产品软件进行游戏及使用付费内容时发生的费用征收。\n' +
          '6. “K-GOLF在线服务”指用户客户访问营业场所使用K-GOLF产品时所享受的所有服务（如在线高尔夫球场使用、用户客户游戏记录、活动开展等）。\n' +
          '7. “K-GOLF在线服务使用费”指用户客户使用“K-GOLF在线高尔夫球场服务”时支付的费用，并以在线球场使用时的方式进行征收。\n' +
          '8. “门店管理员”指公司向业主提供的用于在线管理K-GOLF产品的电脑程序。\n\n' +
          '第3条（游戏计费制度的运营）\n' +
          '1. 计费方式如下。\n' +
          '  1) K-GOLF在线高尔夫球场服务的球场使用费用按每局计费，向业主收取。\n' +
          '  2) 在高尔夫球场使用模式中，从第1洞到第18洞，每洞按照100韩元计费。\n' +
          '  3) 若用户客户因自身原因或门店运营原因中途停止游戏，则按已使用的洞数计费。\n' +
          '2. 根据使用产品的计费如下。\n' +
          '  1) 练习场C产品：仅可使用20个9洞球场，为免计费产品。\n' +
          '  2) 组合型A·练习场B产品：可使用所有内容，使用球场时，按每位用户每洞计费。\n' +
          '3. 支付方式如下。\n' +
          '  1) 原则为后付自动转账支付方式，另有预付款及未付款支付方式。\n' +
          '  2) 业主需一次性支付每月应付总金额。不可部分支付。\n' +
          '  3) 后付自动转账：在指定结算日，自动扣除上月（1日~月底）使用费用（上午/下午共2次）。\n' +
          '  4) 预付款：在指定结算日前2天，通过银行转账或信用卡支付。\n' +
          '  5) 未付款支付：在指定结算日过后由业主自行支付。\n\n' +
          '第4条（支付方式·应收账款处理·使用产品变更）\n' +
          '1. 银行转账·信用卡支付两种方式。\n' +
          '2. 应收账款\n' +
          '  1) 在结算日之后发生的未付款将立即暂停服务使用。\n' +
          '  2) 自应收账款发生日起每日产生延迟利息（0.n%）。\n' +
          '  3) 支付应收账款后服务恢复。\n' +
          '3. 使用产品变更于每月1日生效。\n\n' +
          '第5条（条款外的准则及与相关法律的关系）\n' +
          '1. 未明示事项依照相关法律及惯例处理。\n' +
          '2. 消费者保护相关法律如电子商务法优先适用。\n' +
          '3. 若存在个别条款，则优先适用。\n\n' +
          '第6条（免责条款）\n' +
          '1. 因自然灾害·战争·通信服务商中断等不可抗力情形下，公司不承担责任。\n' +
          '2. 因设备维护·更换等造成的损失，公司不承担责任。\n' +
          '3. 因业主电脑故障或填写错误信息导致的损失，公司不承担责任。\n' +
          '4. 对于收益未达预期或使用资料产生的损失，公司不承担责任。\n' +
          '5. 公司无对帖子内容进行事前审查的义务。\n' +
          '6. 除违反免费服务相关个人信息保护政策外，公司不承担责任。\n\n' +
          '第7条（合同撤销等）\n' +
          '1. 合意撤销·转让时，须事先通知并在结清未付款项后回收服务。\n' +
          '2. 延迟时将按法定利率征收延迟利息。\n' +
          '3. 若部分使用，可收取相应金额与费用。\n\n' +
          '第8条（争议解决）\n' +
          '1. 运营损害赔偿处理部门。\n' +
          '2. 优先处理投诉·申诉，若有延迟，将通知理由及时间安排。\n\n' +
          '第9条（准据法·管辖法院）\n' +
          '1. 以大韩民国法律为准据法。\n' +
          '2. 依据民事诉讼法向有管辖权的法院提起诉讼。',
      privacyText:
          '第1条 总则\n' +
          '株式会社K-GOLF（以下简称“公司”）十分重视用户在使用公司店铺管理系统（https://kms.thekgolf.com）所提供的所有服务时提供的个人信息。公司遵守相关法律（通信秘密保护法、信息通信网法等），并通过隐私政策简明地告知用户个人信息的收集和使用方式。政策如因法律或公司内部方针变更时可予以修订。\n\n' +
          '第2条 个人信息的收集项目、方式及使用目的\n' +
          '一）收集项目\n' +
          '  1) 会员注册·服务提供：姓名、ID、手机号码、地址、电子邮箱（退出时删除）\n' +
          '  2) 账户支付：银行名称、账号、开户人姓名（保留5年）\n' +
          '  3) 虚拟账户：银行名称、汇款人姓名（保留5年）\n' +
          '  4) 信用卡支付：发卡公司、卡号、有效期（保留5年）\n' +
          '  5) 交易信息：IP、Cookie、访问日志、使用记录（退出时删除）\n' +
          '  6) 活动·配送：姓名、地址、电话号码（达成目的后销毁）\n' +
          '  7) 宣传品：姓名、地址、电话号码（达成目的后销毁）\n\n' +
          '二）使用目的\n' +
          '  1) 合同履行·费用结算\n' +
          '  2) 会员管理·身份确认·防止不当使用·处理投诉\n' +
          '  3) 新服务开发·营销·统计·广告\n' +
          '  4) 服务故障时单独通知\n\n' +
          '三）保存期限\n' +
          '  - 服务使用期间内保存，用户退出或请求删除时立即销毁\n' +
          '  - 活动目的达成后立即销毁\n' +
          '  - 不良会员记录自解除日起保留1年\n\n' +
          '四）收集方式\n' +
          '  - 网站、书面、传真、电话、公告栏、电子邮件、活动、Cookie·日志收集工具\n\n' +
          '第3条 个人信息的销毁程序及方法\n' +
          '一）销毁程序：在达成收集目的后，依据公司内部政策及相关法律规定保存一定时间后销毁\n' +
          '二）销毁方法：纸质文件通过碎纸或焚烧处理，电子文件以无法恢复的方式删除\n\n' +
          '第4条 个人信息的共享·提供\n' +
          '原则上未经事前同意不得向外部提供。但在以下情况下例外：\n' +
          '  - 用户已同意的情况\n' +
          '  - 为费用结算、服务违规处理、根据法律机关要求等情况\n\n' +
          '第5条 委托处理\n' +
          '为提升服务质量，公司可委托专业外部机构处理业务，委托合同中将明示法律遵守义务及责任承担\n' +
          '  - 委托业务：信用卡·账户转账·短信服务 → Settlebank\n\n' +
          '第6条 用户权利\n' +
          '用户及其法定代理人可通过公司网站查询、修改、删除个人信息或申请退出会员\n\n' +
          '第7条 同意撤回\n' +
          '用户可通过书面、电话或电子邮件方式请求撤回同意，收到请求后立即处理\n\n' +
          '第8条 Cookie 使用\n' +
          '为提供定制化服务而使用Cookie。用户可通过浏览器设置允许或拒绝使用Cookie，拒绝时部分服务可能受限\n\n' +
          '第9条 保护措施\n' +
          '  - 密码保护、防病毒程序、加密算法、入侵防御系统的使用\n' +
          '  - 仅限相关负责人访问，定期进行培训\n\n' +
          '第10条 儿童信息保护\n' +
          '未满14周岁的用户需获得法定代理人的同意\n\n' +
          '第11条 广告信息发送\n' +
          '未经明确拒绝意向不得发送广告信息；如发送，需标注“广告”字样\n\n' +
          '第12条 负责人联系方式\n' +
          '个人信息保护负责人：金学秀（经营支援室） 1577-0564 / kimhs@thekgolf.com\n' +
          '第13条 修订\n' +
          '施行日期：2021年1月2日',
      refundText:
          '本规定适用于消费者对(株)K-GOLF及其加盟店提前支付，并设定使用期间或次数的内容使用券（例如：月订阅券、次数券、季票等）请求退款的情况，依据相关法律、公正交易委员会消费者纠纷解决标准及业界标准进行运营。\n\n' +
          '第1条（退款事由及标准）\n' +
          '1. 因消费者责任请求退款时\n' +
          '  1) 使用开始前：\n' +
          '    - 自付款日起7日内请求退款时：依据《电子商务法》第17条及第18条第9项，全额退款，无违约金及手续费。\n' +
          '    - 超过7日后请求退款时：撤销申购权失效，适用使用开始后的标准。\n' +
          '  2) 使用开始后：\n' +
          '    - 扣除已使用天数或次数对应金额（按正常单价）后，退还剩余金额。\n' +
          '    - 从剩余金额中扣除10%违约金（手续费）后退款。\n\n' +
          '2. 因商家责任请求退款时\n' +
          '  1) 使用开始前：全额退款。\n' +
          '  2) 使用开始后：未使用的剩余期间或次数金额全额退款，无手续费。\n\n' +
          '第2条（退款程序）\n' +
          '1. 通过书面申请或联系客服中心提出请求。\n' +
          '2. 付款日起7日内请求时，立即全额退款。\n' +
          '3. 使用开始后请求时，扣除已用部分及10%违约金后，于7个营业日内退款。\n' +
          '4. 加盟店→总部转交后进行结算及退款处理。\n\n' +
          '第3条（退款计算示例）\n' +
          '例：月套餐券  100$ ・使用期30天\n' +
          '  - 使用10天后取消\n' +
          '    · 使用金额：10 × 3.3$ = 33$\n' +
          '    · 余额：100 – 33 = 67$\n' +
          '    · 违约金10%：6.7$ \n' +
          '    · 退款金额：60.3$（约60$）\n\n' +
          '第4条（客户咨询处）\n' +
          '退款及咨询：客户中心 +82-1577-0564\n\n' +
          '第5条（法律依据）\n' +
          '· 《关于电子商务等消费者保护法》第17条、第18条\n' +
          '· 同法施行令第21条\n' +
          '· 《消费者纠纷解决标准》（公正交易委员会公告第2023-14号)',
    },
    tournament: {
      list: {
        tournamentOpen: '比赛开设',
        tournamentId: '比赛号码',
        title: '比赛名',
        tournamentType: '开设类型',
        period: '期间',
        participantCount: '参加人员',
        courseCount: '球场数量',
        modify: '修改',
        etc: '其他',
        expires01: '新的锦标赛系统计划在七月更新。 更新后，玩家每场比赛最多可以选择四个球场。',
        expires02: '对于更新之前安排的比赛，请将结束日期设置为不晚于 2024 年 9 月 15 日。',

        modifyPossibility: '可修改',
        modifyImpossibility: '不可修改',
        listDelete: '删除',
        earlyTermination: '提前结束',
        awarding: '颁奖',
        awardAnnouncement: '发布颁奖',
        awardRecipientsView: '颁奖明细',

        statusFilter: {
          all: '所有',
          proceeding: '进行中',
          expected: '预计',
          end: '结束',
        },

        popup: {
          deleteTournamentConfirm: {
            text1: '请问需要删除所选比赛吗？',
            text2: '※删除比赛将无法复原',

            requestSuccess: '已经删除比赛',
            requestFail: '删除比赛失败\n请重新删除',
          },
          earlyEndTournamentConfirm: {
            text1: '请问基于目前时间结束该比赛吗？',
            text2: '※ 如果结束比赛，您将无法参加比赛',
            text3: '但是，目前参与比赛的选手可以比赛',

            requestSuccess: '比赛提前结束了。',
            requestFail: '提前结束比赛失败\n请重新结束',
          },
        },
      },

      open: {
        tournamentTerm: '比赛条款',
        acceptTerms: '条款同意',

        participatingStoresSettingAlert: '只能开10个。',
        participatingStoresSetting: '参与店铺设置',
        addParticipatingStore: '参与店铺店铺',
        country: '国家',
        province: '诗/道',
        city: '市/郡/区',
        participatingStore: '参与店铺',

        basicSetting: '基本设定',
        tournamentTitle: '比赛名',
        tournamentTitlePlaceholder: '请输入比赛名 韩语20字,英文40字以内)',
        tournamentTitleInvalidMessage: '请输入40字以内比赛名',
        tournamentIntroduce: '比赛介绍',
        tournamentIntroducePlaceholder: '请简单输入比赛介绍 (韩语100字,英文120字以内)\n※若不输入将会显示空栏。',
        tournamentIntroduceInvalidMessage: '请输入120字以内比赛介绍',
        tournamentSummary: '比赛概要',
        tournamentParticipantTerms: '参与者使用条款',
        tournamentSummaryDefaultValue:
        'K高尔夫比赛使用条款\n' +
            'K高尔夫比赛是由K高尔夫总部、K高尔夫店主或店主协会代表主办，利用K高尔夫的程序和设备举办的模拟高尔夫比赛。\n' +
            '\n' +
            '第1条: 参赛资格\n' +
            '除非正常会员外，所有正式注册为K高尔夫会员的用户均可参加。\n' +
            '非正常会员及非会员可参加比赛，但其所有回合记录将从排名、统计及奖项中排除。\n' +
            '（非正常会员指因参与不正当活动而受到制裁或处罚的会员，或持有相应违规判定账号的用户。）\n' +
            '\n' +
            '第2条: 参赛方式\n' +
            '在全国任意K高尔夫门店登录后，进入比赛模式，从比赛列表中选择要参加的比赛并完成回合。\n' +
            '除门店的回合费用外，无需支付额外参赛费。\n' +
            '每人仅限使用一个以本人名义注册的账号参加。使用他人账号或多个账号参赛的情况，将取消所有账号的参赛资格，并排除在奖项范围之外。\n' +
            '\n' +
            '第3条: 奖项规则\n' +
            '比赛结束后，可通过K高尔夫App查看最终排名。违反比赛规则者将被取消获奖资格。\n' +
            '（非会员及店主不参与奖项评选。）\n' +
            '奖项条件由比赛主办方决定，按通知规定进行颁奖。根据比赛进程，奖项内容可能有所变动。\n' +
            '若会员的联系方式（手机号、地址）不正确，主办方有权取消其获奖资格。\n' +
            '店主主办的比赛，K高尔夫总部不对比赛条件及奖项进行干预，也不承担相关责任。\n' +
            '若出现积分并列的情况，排名将按照完成回合数、倒计分及最后一回合的开始时间顺序决定。\n' +
            '如为多场地比赛，倒计分的计算以场地排名中的回合总分进行计算。\n' +
            '\n' +
            '第4条: 比赛规则\n' +
            '登录的情况下，回合结束后分数卡提交及排名将自动完成。\n' +
            '仅认可完成18洞的回合。未完成回合的记录不计入排名及奖项。\n' +
            '若无法通过摄像头确认身份，将被视为失格。\n' +
            '回合规则遵循K高尔夫程序，基本条件及中途放弃等由主办方决定。\n' +
            '因程序问题或自然灾害等原因，预先通知的门店比赛可能取消，正在进行的比赛可能中断。\n' +
            '如因门店状况（如网络不稳定、停电等）而非服务问题导致的异常，由主办方与参赛者协商解决。\n' +
            '为解决不可避免的情况，可使用指定数量的补救球（Mulligan）。如无异常情况，也可自行决定是否使用。\n' +
            '可使用个人球杆，主办方可查看录像以确认身份，发现违规行为将视为失格。此外，任何电脑操控行为也将导致失格处理。\n' +
            '参赛者必须熟知预先通知的比赛条件，若违反将可能被判定失格。\n' +
            '\n' +
            '第5条: 补充规定\n' +
            '如不服从主办方指示或未履行相关要求，参赛资格将被限制。\n' +
            '比赛结束后，原则上不接受任何问题或异议。\n' +
            '参赛者因系统故障提出问题时，将通过记录验证决定是否受理。\n' +
            '比赛期间保存的视频将用于奖项审核，且在一定时间后删除。',
        tournamentThumbnail: '比赛头像',

        participationTarget: '参加对象',
        participationTargetDescription: '无性别与年龄区分都可以参加',
        addParticipationTarget: '添加参赛对象',
        participationTargetLimitType: '限制区分',
        participationTargetName: '区分名',
        participationTargetFullName: '参赛对象区分名',
        participationTargetGender: '性别',
        participationTargetBirthYearLimit: '限出生年度',
        participationTargetType: '参赛对象类型',
        participationTargetMinimumBirthYear: '最小出生年度',
        participationTargetMaximumBirthYear: '最大出生年度',
        participationTargetBirthYearMessage1: '不能选择开始年度的前面年度',
        participationTargetBirthYearMessage2: '不能选择结束年度的后面年度',
        participationTargetTeeBoxTypeSetting: '发球位置设定',

        participationGrade: '参加等级',

        participationConditions: '参加条件',
        participationConditionsDescription: '不管原有聊天记录都可以参加',
        addParticipationConditions: '添加参赛条件',
        participationConditionsLimitType: '限制区分',
        participationConditionsTournamentList: '比赛目录',
        participationConditionsRankingsLitmit: '排名显示',
        participationConditionType: '参加条件类型',
        participationConditionsTournamentTitlePlaceholder: '请搜索比赛',

        participationPeriod: '参赛期间',

        participatePublic: '参与方式',
        participatePublicPlaceholder: '密码(四位数字)',

        public: '公开',
        nondisclosure: '非公开',

        courseSetting: '球场设置',
        courseCount: '球场数量',
        courseCountUnit: '个',
        courseSelection: '球场选择',
        courseNumber: 'No',
        courseTitle: '球场名',
        courseType: '球场类型',
        courseDifficulty: '球场难度',
        greenDifficulty: '果岭难度',
        longestHole: '最远距洞',
        nearpinHole: '最进距洞',
        newPerio: '新贝利亚',
        outCourseHole: '前半场',
        inCourseHole: '后半场',

        gameSetting: '比赛设定',
        difficultyEasy: '容易',
        difficultyNormal: '普通',
        difficultyHard: '难',
        difficultyManual: '手动',
        courseStartOrder: '球场开始顺序',
        courseStartValue1: '前半场 > 后半场',
        courseStartValue2: '后半场 > 前半场',
        userDifficulty: '玩家难度',
        swingPlate: '动感平台',
        mulliganCount: '摸杆次数',
        windPower: '风速',
        holeCupPosition: '洞杯位置',
        greenPosition: '果岭位置',
        concede: 'OK球',
        greenSpeed: '果岭速',
        puttingLineCount: '果岭线引导次数',
        greenHardness : '果岭硬度',
        teeBox: '发球位置',
        guideDistance: '目标距离',

        participantHandicap: '参赛者差点',
        calibrationGrade: '分等级校准',
        userGrade: '会员等级',
        scoreCorrection: '成绩校准',
        calibrationParticipant: '分参赛对象校准',

        rankingCriteria: '排名计算标准',
        rankingCriteriaDescription1: '排名计算标准设定指的是?',
        rankingCriteriaDescription2: '同位者多人时，决定该同位者的排名顺序的标准设定',
        rankingCriteriaOne: '第一',
        rankingCriteriaGameRoundCount: '按比赛记录多的顺序',
        rankingCriteriaGameRoundCountButton: '按比赛记录多的顺序指的是？',
        rankingCriteriaGameRoundCountDescription: '当成绩相同时，完成 18 洞轮数较多的选手排名靠前。',
        rankingCriteriaTwo: '第二',
        rankingCriteriaOrderByGameRoundDesc: '回溯计算',
        rankingCriteriaCountbackDescription: '按照比赛各球场已登记回合的9洞总和、6洞总和、3洞总和和最后一洞总和的顺序进行回溯计算。此回溯计算仅适用于总排名。',
        rankingCriteriaThree: '第三',
        rankingCriteriaBackCount: '使用后半场计分方式',
        rankingCriteriaBackCountButton: '后半场计分方式指的是？',
        rankingCriteriaLastRoundStartTime: '最后一轮开始时间',
        rankingCriteriaLastRoundStartTimeDescription: '当成绩和比赛记录相同时，以最后一轮开始时间为准，完成18洞的选手登记为较高的排名。',
        rankingCriteriaUse: '使用',
        rankingCriteriaUnused: '未使用',

        awardSetting: '颁奖设定',
        addAward: '添加颁奖明细',
        awardName: '颁奖名',
        awardNamePlaceholder: '请输入颁奖名',
        awardGender: '区分性别',
        awardGenderAll: '不区分',
        awardItem: '颁奖项目',
        awardType: '颁奖类型',
        awardCourse: '区分球场',
        awardCourseTotal: '球场综合',
        awardRankingType: '区分排名',
        awardSingleRanking: '单一排名',
        awardRanegeRanking: '范围排名',
        awardRankingRange: '排名范围',
        awardRankingPlaceholder: '请输入排名',
        awardRankingRangeText1: '从',
        awardRankingRangeText2: '到',
        awardProduct: '颁奖商品',
        awardProductPlaceholder: '请输入颁奖商品',

        whetherLimit: '限制与否',
        unLimit: '未限制',
        delete: '删除',
        all: '所有',
        yearUnit: '年',
        yearRangeText1: '从',
        yearRangeText2: '到',

        save: '保存',
        modify: '修改',

        navigation: {
          step1: '同意条款',
          step2: '比赛设定',
          step3: '比赛开设',
        },

        popup: {
          courseSelection: {
            title: '选择比赛场地',
            courseSearch: '球场搜索',
            courseSearchPlaceholder: '请搜索球场',
            selection: '选择',
            save: '保存',
            cancel: '关闭',

            message1: '您不能再选择球场了',
            message2: '请选择球场',
          },
          rankingCriteriaGameRoundCount: {
            text1: '参加开设的比赛，并完成该球场的记录越多的玩家排名越高的记录功能',
            cancel: '关闭',
          },
          rankingCriteriaBackCount: {
            text1: '玩家成绩分为前半场/后半场',
            text2: '※ 在这里前半场和后半场指的是先打的9个洞为前半场, 后打的9个洞为后半场',
            text3: '洞编号为10洞, 也不一定是后半场',
            text4: '后半(9洞)总成绩更好的玩家排名更高',
            text5: '- 最后打完的洞开始数到9洞',
            text6: '后半(6洞)总成绩更好的玩家排名更高',
            text7: '- 从最后打完的洞数到6洞',
            text8: '后半 (3洞) 总成绩更好的玩家排名更高。',
            text9: '- 从最后打完的洞开始数到3洞',
            text10: '比较最后打的洞的成绩，成绩更好的玩家排名更高。',
            cancel: '关闭',
          },
          shopTournamentOpenConfirm: {
            text1: '使用填写的内容开设比赛吗？',
            text2: '开设的比赛在比赛清单中可以查看及修改。',

            title: '这是已经使用的比赛名称。 请输入其他比赛名称。',

            requestSuccess: '店铺比赛开设完成',
            requestFail: '店铺比赛开设中出现错误。\n请稍后再试。',
          },
          shopTournamentModifyConfirm: {
            text1: '请问按照内容修改比赛吗？',

            title: '这是已经使用的比赛名称。 请输入其他比赛名称。',

            requestSuccess: '已经完成店铺比赛修改',
            requestFail: '修改店铺比赛时发生错误。\n请稍后再试',
          },
        },

        alert: {
          message1: '必须输入至少1个以上参赛对象',
          message2: '差点限-99到99范围内的值',
          message3: '比赛开始时间基于目前时间过24小时后',
          message4: '比赛时间设定最长1年',
          message5: '球场设定空白，请填写球场设定',
          message6: '授奖设定内容空白，请填写授奖设定',
          message7: '把开始顺序调小一点',
          message8: '密码需要输入4位数字。',
          message9: '您设置的排名有错误。 请确认。\n示例：无法输入-1 和0 等数字。',
          message10: '请输入奖项名称。',
          message11: '请输入比赛名称。',
          message12: '新增奖励详情请设置奖励项目。',
          message13: '请检查课程数量并选择课程',
        },

        isParticipationGrade: '等级是否使用等级使用与否',
        participationGradeText1:
          '等级使用时<img src="/images/icon/ui_icon_grade_0_0.png" alt="grade" class="icon_grade" /><img src="/images/icon/ui_icon_grade_1_0.png" alt="grade" class="icon_grade" /> 等级会员不能参加比赛。',
        participationGradeSelectTitle: '参加对象',
        participationGradeSelectNoUse: '无限制',
        participationGrade2: 'Bronze',
        participationGrade3: 'Silver',
        participationGrade4: 'Gold',
        participationGrade5: 'Platinum',
        participationGrade6: 'Diamond',
        participationKHandiText6: '-0.1以下（用户下）',
        participationKHandiText5: '0.0 以上 ~ +7.9 以下（单用户）',
        participationKHandiText4: '+8.0 以上 ~ +17.9 以下（80 位用户）',
        participationKHandiText3: '+18.0 以上 ~ 27.9 以下（第 90 位命中者）',
        participationKHandiText2: '+28.0以上~（点击量100次以上的用户）',
        participationGradeText6_3: 'Diamond等级全部的 10以下',
        participationGradeText6_2: 'Diamond等级全部的 10%以上~30%以下',
        participationGradeText6_1: 'Diamond等级全部的 30%以上~',
        participationGradeText5_3: '差点 0.0 以上 ~ 2.0 以下',
        participationGradeText5_2: '差点 2.1 以上 ~ 5.0 以下',
        participationGradeText5_1: '差点 5.1 以上 ~ 7.9 以下',
        participationGradeText4_3: '差点 8.0 以上 ~ 10.0 以下',
        participationGradeText4_2: '差点 10.1 以上 ~ 14.0 以下',
        participationGradeText4_1: '差点 14.1 以上 ~ 17.9 以下',
        participationGradeText3_3: '差点 18.0 以上 ~ 20.0 以下',
        participationGradeText3_2: '差点 20.1 以上 ~ 24.0 以下',
        participationGradeText3_1: '差点 24.1 以上~ 27.9 以下',
        participationGradeText2_3: '差点 28.0 以上 ~ 38.0 以下',
        participationGradeText2_2: '差点 38.1 以上 ~ 48.0 以下',
        participationGradeText2_1: '差点 48.1以上~',
        calibration: '修正值',
        kHandi: 'K Handi',
        criteria: '准绳',
        notAllowed: '参加不可',
      },

      details: {
        tab: {
          summary: '比赛概要',
          information: '比赛信息',
          ranking: '比赛名次',
          award: '比赛颁奖',
          awardHistory: '颁奖明细',
          participantTerms: '参与者使用条款',
          participatingStoresList: '参与店铺目录',
        },

        information: {
          introduce: '比赛介绍',

          tournamentPeriod: '比赛期间',
          participatePublic:'参与方式',

          participationTarget: '参赛对象',
          participationNoLimit: '不限制',
          participationTargetName: '不区分',
          participationTargetFullName: '区分参赛对象名',
          participationTargetMinimumBirthYear: '最小出生年度',
          participationTargetMaximumBirthYear: '最大出生年度',
          participationTargetTeeBoxSetting: '发球位置设定',

          participationGrade: '参赛等级',
          gradeParticipationAvailability: '能否参赛',
          participationPossible: '可以参赛',
          unableParticipate: '不可以参赛',

          participationConditions: '参赛条件',
          participationConditionTournamentName: '比赛名',
          participationConditionRankingLimit: '排名限制',

          tournamentCourse: '比赛球场',
          courseNumber: '球场号',
          courseName: '球场名',
          courseLongest: '最远距',
          courseNearpin: '最近洞',
          sinperioExclusionHall: '新贝利亚除外洞',

          userDifficulty: '选手难度',
          swingPlate: '动感平台',
          mulliganCount: '摸杆次数',
          windPower: '风速',
          holeCupPosition: '洞杯位置',
          greenPosition: '果岭位置',
          concede: 'OK球',
          greenSpeed: '果岭速',
          puttingLineCount: '果岭线次数',
          teeBox: '发球位置',
          greenHardness: '果岭硬度',
          calibrationGrade: '分等级校准',
          guideDistance: '目标距离',

          calibrationParticipant: '分参赛对象校准',

          awardItem: '颁奖项目',
          awardName: '颁奖名',
          awardType: '颁奖类型',
          awardCourse: '球场部分',
          awardRankingType: '排名区分',
          awardSingleRanking: '单一排名',
          awardRanegeRanking: '范围排名',
          awardRankingRange: '排名范围',
          awardRankingUnit: '等',
          awardProduct: '颁奖奖品',
          awardNone: '不存在',
          awardAll: '全部',

          awardAnnouncement: '授奖者发布',
          scoreCorrection: '成绩校准',
          genderNoLimit: '无关',
          participationGradeTitle: '参加对象及补正信息',
        },

        participatingStoresList: {
          country: '国家',
          province: '诗/道',
          city: '市/郡/区',
          participatingStore: '参与店铺',
          all: '全部',
        },

        ranking: {
          courseTotalScore: '总成绩',
          searchTextBoxPlaceholder: '请输入昵称',

          allRanking: '所有排名顺序',
          allRankingOption1: '按排名高的顺序',
          allRankingOption2: '按排名低的顺序',
          allRankingOptionReset: '初始化',

          genderRanking: '性别排名顺序',
          genderRankingOption1: '限女性',
          genderRankingOption2: '限男性',
          genderRankingOptionAll: '所有',

          nickname: '昵称',
          participationCount: '参赛次数',
          teeBoxLocation: '发球台位置',
          totalDistance: '飞行距离 (m)',
          remainDistance: '剩余距离 (m)',
          recordTime: '达成时间',
          lastRoundStartTime: '最后一轮开始时间',
          newPerioScoreRecord: '12洞成绩',
          finalScore: '最终成绩',
          birdieCount: '柏忌数',
          eagleCount: '老鹰数',
          courseName: '球场名字',
          holeNumber: '洞编号',
          courseDistance: '总长距离',
          totalParticipationCount: '总参赛次数',
          gradeRankingOption1: '高序',
          gradeRankingOption2: '低序',
          handicap: '差点',
        },

        awardRanking: {
          allChoice: '全选',
          awardConfirmation: '颁奖确定',
          resetAwards: '颁奖初始化',
          awardRecipientsSelection: '授奖者选定',

          courseScore: '球场成绩',
          handicap: '差点',
          additionalHandicap: '追加差点',
          adjustmentResult: '调整结果',
          adjustmentSynthesis: '调整综合',
          finalScore: '最终成绩',
          courseOverall: '球场综合',
          swingVideo: '挥杆影像',
          videoPlay: '影像回放',

          alert: {
            message1: '差点限-99到99范围内的值',
          },
        },

        awardHistory: {
          rankingUnit: '第',

          ranking: '排名',
          nickname: '昵称',
          record: '记录',
          recordTime: '达成时间',
          totalParticipationCount: '总参赛次数',
          courseName: '球场名',
          holeNumber: '洞编号',
        },

        course: '课程',
        summation: '求和',
        gender: '性别',
        grade: '参加时等级',
        startGrade: '开始评分',
        lastGrade: '最终的评分',
        handicapGrade: '评分',
        storeUse: '利用店铺',
        public: '公开',
        nondisclosure: '非公开',

        alert: {
          message1: '比赛结束后需过24小时',
          message2: '选定比赛授奖者后可以查看授奖内容',
        },

        popup: {
          resetTournamentAwardsConfirm: {
            text1: '请问确定授奖初始化吗？',
            text2: '假如确定授奖初始化，目前登记的追加差点及授奖确定内容将会全部初始化',

            requestSuccess: '授奖明细全部初始化',
            requestFail: '授奖内容初始化失败。\n请重新操作',
          },

          tournamentAwardRecipientsSelectionConfirm: {
            text1: '基于目前登记的授奖确定，选定授奖者吗？',
            text2: '登记的内容可在授奖明细页确认',
            text3: '一旦公布获奖者，排名将无法更改。',
            text4: '若要修改排名，您必须先“初始化奖项”，然后才能进行任何调整。',

            requestSuccess: '已完成选定授奖者。\n请授奖明细页确认',
            requestFail: '授奖者选定失败。\n请重新操作',
          },

          tournamentAwardAnnouncementConfirm: {
            text1: '一旦发布授奖者，就无法修改授奖者',
            text2: '请问您要发布授奖者吗？',

            requestSuccess: '已完成授奖者发布',
            requestFail: '授奖者发布失败',
          },
        },
      },

      awardItem: {
        Score: '成绩',
        Longest: '最远距',
        Nearpin: '最近洞',
        HoleInOne: '一杆进洞',
        CourseRoundPlayCount: '下场次数',
      },
      awardType: {
        Stroke: '比杆',
        NewPerio: '新贝利亚',
        BirdieCount: '柏忌数',
        EagleCount: '老鹰数',
      },
    },
    control: {
      image: {
        delete: '删除',
        fileSelect: '选择文件',
      },
    },
    contentsItem: {
      info: {
        prevItem: '以前的购买信息',
        prevItemText: '这是无法再购买的内容通行证。 <br/>如需购买，请联系服务运营团队。',
        itemText: '该产品在购买后自动应用。',
        alertMsgTitle: '内容使用信息',
        alertMsgSubTitle: '正在使用的票证信息',
        alertMsgUser: '你好。 {user}先生。',
        paymentMsg: '购买的内容产品已按如下方式应用。',
        paymentTitle: '选择付款方式',
      },
      button: {
        payment: '去买',
        purchase: '买',
        rePurchase: '再次购买',
        creditCard: '信用卡',
        cash: '现金支付',
        paypal: 'PayPal',
      },
      shopSupplyItem: {
        salesCode:'材料代码'
      },
      1010110110: {
        title: '内容票（期限）',
        icon: '/itemImage/ui_icon_period.png',
        unit: 'DAYS',
        itemInfo: '店铺机器',
        itemDescription: '这是内容使用通行证（有期限），允许您使用游戏内容 {count} 天。',
        itemPayment: '已添加 {count} 天，因此您可以使用该内容 {newCount} 天。',
        alertMsg: '店铺中使用的所有内容使用通行证（期限）将在 {count} 天后用完。 为了顺利使用内容，请购买内容使用权（期限）。',
        alertMsgNone: '店铺内使用的所有内容（限期）已售完。 \n如果您没有内容许可证（有期限），则无法玩新游戏。 \n请前往店铺购买内容订阅（期间）。',
      },
      1010120110: {
        title: '内容票（洞）',
        icon: '/itemImage/ui_icon_round.png',
        unit: 'HOLE',
        itemDescription: '这是一张内容凭证（洞），可让您使用多达 {count} 个洞的游戏内容。',
        itemPayment: '增加了 {count} 个洞后，内容就可以使用 {newCount} 个洞了。',
        alertMsg: '店铺中尚有 {count} 个内容通行证（洞）仍在使用。 为了顺利使用内容，请购买内容使用券（大厅）。',
        alertMsgNone: '店铺中尚有 {count} 个内容通行证（洞）仍在使用。 如果内容票（洞）少于 {round} 洞，您将无法玩新游戏。 请前往店铺购买内容通行证（洞）。',
      },
      alertMsg: {
        all: '商店内使用的{day}天内容使用券（限期）和内容使用券（洞）将在打完{count}洞后耗尽，因此请购买内容使用券（限期）或内容使用券（洞） ）以顺利使用内容。',
        allNone: '在店铺中使用的内容使用券（期限）已变为{day}天，并且正在使用的内容使用券（洞）已变为{round}洞以下。 \n如果您没有足够的内容，您将无法玩新游戏。 \n请前往店铺并购买内容访问权限。',
      },
      // 소모품 구매
      51101511111011: {
        title: 'Mat S Type Stance Mat',
        icon: '/itemImage/KGFMAT001012.jpg',
        unit: 'ea',
        itemDescription: '包含橡胶底座的站立垫，尺寸 1100x1300 毫米。<br />* 您可以在付款管理菜单中查看订单状态。',
        salesCode: '100061',
      },
      51101511111012: {
        title: 'Mat S Type (Left/Right) Fairway Mat Set',
        icon: '/itemImage/KGFMAT001013.jpg',
        unit: 'set',
        itemDescription: '一体式垫子套装，带球道、长草区、沙坑和橡胶底座，600x1300 毫米。<br />* 您可以在付款管理菜单中查看订单状态。',
        salesCode: '100062',
      },
      51101511111013: {
        title: 'Mat S Type Cut-Out Fairway Mat',
        icon: '/itemImage/KGFMAT002015.jpg',
        unit: 'ea',
        itemDescription: '球道垫，带长草区和沙坑开口，底部带魔术贴，尺寸：600x1300mm。<br />* 您可以在付款管理菜单中查看订单状态。',
        salesCode: '100081',
      },
      51101511111014: {
        title: 'Mat S Type Fairway Mat',
        icon: '/itemImage/KGFMAT002016.jpg',
        unit: 'ea',
        itemDescription: '球道垫，带顶面和双色草皮，尺寸：370x1300mm。<br />* 您可以在付款管理菜单中查看订单状态。',
        salesCode: '100082',
      },
      51101511111015: {
        title: 'Mat S Type Rubber base',
        icon: '/itemImage/700004.jpg',
        unit: 'ea',
        itemDescription: '橡胶底，带沙坑和长草区开口，尺寸：600x1300mm。<br />* 您可以在付款管理菜单中查看订单状态。',
        salesCode: '100073',
      },
      51101511111016: {
        title: 'Mat S Type Rough Mat',
        icon: '/itemImage/KGFMAT002001.jpg',
        unit: 'ea',
        itemDescription: '长草垫，底部带魔术贴，尺寸：400x230mm。<br />* 您可以在付款管理菜单中查看订单状态。',
        salesCode: '100067',
      },
      51101511111017: {
        title: 'Mat S Type Grey Bunker Mat',
        icon: '/itemImage/KGFMAT002017.jpg',
        unit: 'ea',
        itemDescription: '灰色沙坑垫，底部带魔术贴，尺寸：400x230mm。<br />* 您可以在付款管理菜单中查看订单状态。',
        salesCode: '100083',
      },
      51101511111018: {
        title: 'Mat S Type Silver Brush Bunker Mat',
        icon: '/itemImage/KGFMAT001011.jpg',
        unit: 'ea',
        itemDescription: '银色刷状沙坑垫，钢底带魔术贴，尺寸：400x230mm。<br />* 您可以在付款管理菜单中查看订单状态。',
        salesCode: '100060',
      },
      51101512111011: {
        title: 'Mat KDR Type Stance Mat',
        icon: '/itemImage/KGFMAT001015.jpg',
        unit: 'ea',
        itemDescription: '站姿垫，带橡胶底，尺寸：1000 x 1000mm。<br />* 您可以在付款管理菜单中查看订单状态。',
        salesCode: '100064',
      },
      51101512111012: {
        title: 'Mat KDR Type Fairway Mat',
        icon: '/itemImage/KGFMAT001017.jpg',
        unit: 'ea',
        itemDescription: '球道垫，带橡胶底和双色草皮，尺寸：500x1000mm。<br />* 您可以在付款管理菜单中查看订单状态。',
        salesCode: '100066',
      },
      51101513111011: {
        title: 'Auto Tee Type  Auto Tee up System',
        icon: '/itemImage/100175.jpg',
        unit: 'ea',
        itemDescription: '内置自动发球系统套装，含集成地板按键。<br />* 您可以在付款管理菜单中查看订单状态。',
        salesCode: '100175',
      },
      51101514111012: {
        title: 'Consumables Type Rubber Tee',
        icon: '/itemImage/100187.jpg',
        unit: 'ea',
        itemDescription: '橡胶球座 (JE)<br />* 您可以在付款管理菜单中查看订单状态。',
        salesCode: '100187',
      },
      51101514111013: {
        title: 'Consumables Type Rubber Tee (Moving Swing Plate)',
        icon: '/itemImage/100188.jpg',
        unit: 'ea',
        itemDescription: '适用于挥杆板的橡胶球座，兼容 JE 自动上杆系统。<br />* 您可以在付款管理菜单中查看订单状态。',
        salesCode: '100188',
      },
      51101517700001: {
        title: 'Mat BGS Type Fairway Mat',
        icon: '/itemImage/700001.jpg',
        unit: 'ea',
        itemDescription: '球道垫采用双色草皮，底部为魔术贴，尺寸为 370x1040mm。<br />* 您可以在付款管理菜单中查看订单状态。',
        salesCode: '700001',
      },
      51101517700002: {
        title: 'Mat BGS Type Fairway Extension Mat 1',
        icon: '/itemImage/700002.jpg',
        unit: 'ea',
        itemDescription: '球道垫延长板。底部采用魔术贴。尺寸 230x240 毫米。<br />* 您可以在付款管理菜单中查看订单状态。',
        salesCode: '700002',
      },
      51101517700003: {
        title: 'Mat BGS Type Fairway Extension Mat 2',
        icon: '/itemImage/700003.jpg',
        unit: 'ea',
        itemDescription: '球道垫延长板。底部采用魔术贴。尺寸为 260x600 毫米。<br />* 您可以在付款管理菜单中查看订单状态。',
        salesCode: '700003',
      },
      51101517700004: {
        title: 'Mat BGS Type Fairway Mat Rubber base',
        icon: '/itemImage/700004.jpg',
        unit: 'ea',
        itemDescription: '球道套装橡胶底座，顶部采用魔术贴，尺寸 600x1300 毫米。<br />* 您可以在付款管理菜单中查看订单状态。',
        salesCode: '700004',
      },
      51101517700005: {
        title: 'Mat BGS Type Rough Mat',
        icon: '/itemImage/700005.jpg',
        unit: 'ea',
        itemDescription: '粗糙垫，魔术贴底部，尺寸 400x230 毫米。<br />* 您可以在付款管理菜单中查看订单状态。',
        salesCode: '700005',
      },
      51101517700007: {
        title: 'Mat BGS Type Stance Mat',
        icon: '/itemImage/700007.jpg',
        unit: 'ea',
        itemDescription: '站姿垫，橡胶底部，尺寸 1100x1300 毫米。<br />* 您可以在付款管理菜单中查看订单状态。',
        salesCode: '700007',
      },
      51101517700009: {
        title: 'Mat BGS Type Fairway Set (Right Hand)',
        icon: '/itemImage/700009.jpg',
        unit: 'ea',
        itemDescription: '右手一体式球道垫套装，包含球道、长草、沙坑和橡胶底，尺寸 600x1300mm。<br />* 您可以在付款管理菜单中查看订单状态。',
        salesCode: '700009',
      },
      51101517700010: {
        title: 'Mat BGS Type Fairway Set (Left Hand)',
        icon: '/itemImage/700010.jpg',
        unit: 'ea',
        itemDescription: '左手一体式球道垫套装，包含球道、长草区、沙坑和橡胶底，尺寸 600x1300mm。<br />* 您可以在付款管理菜单中查看订单状态。',
        salesCode: '700010',
      },
      51101517100175: {
        title: 'Auto Tee Type Auto Tee up System(Right Hand)',
        icon: '/itemImage/100175.jpg',
        unit: 'ea',
        itemDescription: '右手内置自动发球系统套装，配有集成地板键盘。<br />* 您可以在付款管理菜单中查看订单状态。',
        salesCode: '100175',
      },
      51101517100176: {
        title: 'Auto Tee Type Auto Tee up System (Left Hand)',
        icon: '/itemImage/100176.jpg',
        unit: 'ea',
        itemDescription: '左手型内置自动发球系统套装，含集成地面键盘。<br />* 您可以在付款管理菜单中查看订单状态。',
        salesCode: '100176',
      },
      51101517100222: {
        title: 'Mat BGS Type Bunker Mat',
        icon: '/itemImage/100222.jpg',
        unit: 'ea',
        itemDescription: '沙坑垫采用钢底，带魔术贴，尺寸为 400x230 毫米。<br />* 您可以在付款管理菜单中查看订单状态。',
        salesCode: '100222',
      },
      51101514111011: {
        title: 'Consumables Type Rubber Tee',
        icon: '/itemImage/100186.jpg',
        unit: 'ea',
        itemDescription: '橡胶球座（CT&G）<br />* 您可以在付款管理菜单中查看订单状态。',
        salesCode: '100186',
      },
      51101514111014: {
        title: 'Consumables Type Marking Golf Balls',
        icon: '/itemImage/KGFBAL001001.jpg',
        unit: 'box',
        itemDescription: '标有 4 点图案，每盒 300 个球。<br />* 您可以在付款管理菜单中查看订单状态。',
        salesCode: '100166',
      },
    },
  },
};
